import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, CTA_LABEL } from '../data/site';
const ecosystem = ['Lezioni.', 'Grammar.', 'Vocabulary.', 'Speaking.', 'Reading.', 'Writing.', 'Activities.', 'Games.', 'Assessment.', 'Planning.', 'Homework.', 'Online teaching.', '1-to-1 teaching.', 'Real-life communication.'];
export function FinalCTA() {
  return <section className="border-t-8 border-brand-orange bg-brand-navy px-4 py-8 text-white" data-id="element-44" data-mp="m46s2raobmt0">
      <div className="mx-auto max-w-2xl text-center" data-id="element-45" data-mp="h6ncno28p3zh">
        <p className="font-display text-sm font-extrabold uppercase tracking-widest text-brand-orange" data-id="element-46" data-mp="h3rafnjczt58">
          Un’ultima cosa...
        </p>

        <h2 className="mt-1.5 font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-47" data-mp="qvf0bk09p24l">
          Quante altre lezioni vuoi ancora preparare partendo da zero?
        </h2>

        <div className="mt-2.5 space-y-1 text-[15px] font-medium leading-snug text-white/85" data-id="element-48" data-mp="zx4qkmiexv0s">
          <p data-id="element-49" data-mp="2c5g5o456wyuw">Non hai bisogno di altre cartelle piene di materiale casuale.</p>
          <p data-id="element-50" data-mp="2h3hocnypew5u">
            Hai bisogno di sapere che quando arriva il momento di preparare la
            prossima lezione puoi aprire un unico sistema e trovare una base
            concreta da cui partire.
          </p>
        </div>

        <ul className="mt-3 flex flex-wrap justify-center gap-1.5" data-id="element-51" data-mp="2r2yq4uau4pwj">
          {ecosystem.map(item => <li key={item} className="rounded border border-white/20 bg-white/10 px-2 py-1 text-[12px] font-semibold leading-tight text-white" data-id="element-52" data-mp="2v2r5pqynbwbe">
              {item}
            </li>)}
        </ul>

        <div className="mt-3 space-y-1 text-[15px] font-medium leading-snug text-white/85" data-id="element-53" data-mp="39sf52mn9okwh">
          <p data-id="element-54" data-mp="39u9jrj7y3gs4">Tutto organizzato all’interno dello stesso ecosistema.</p>
          <p data-id="element-55" data-mp="3etcn8z8a1exz">La tua esperienza come insegnante continuerà a fare la differenza.</p>
          <p data-id="element-56" data-mp="3itwl650ocml6">
            Ma la preparazione non deve necessariamente occupare così tanto del
            tuo tempo.
          </p>
        </div>

        <div className="mt-4 rounded-xl border-4 border-brand-green bg-white/10 p-4" data-id="element-57" data-mp="1ep8pzqmll87s">
          <a href={CHECKOUT_URL} className="block" data-id="element-58" data-mp="1en5symn12etk">
            <img src={BOX_IMAGE} alt="Box ENGLISH TEACHER PRO™" className="mx-auto w-full max-w-[200px] drop-shadow-2xl" data-id="element-59" data-mp="1showx2imdqdz" />
          </a>
          <p className="mt-2 font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-60" data-mp="22e1r01i2u699">
            ENGLISH TEACHER PRO™
          </p>
          <p className="mt-1 text-[13px] font-bold leading-snug text-white/85" data-id="element-61" data-mp="1xi475l7luhrq">
            The Complete Ready-to-Use Teaching System for English Teachers
          </p>
          <p className="mt-1 text-[13px] font-extrabold uppercase text-brand-orange" data-id="element-62" data-mp="27efm6iykxlpv">
            Sistema Completo 6-in-1 + 5 Bonus
          </p>

          <p className="mt-3 text-sm font-bold text-white/70" data-id="element-63" data-mp="d06au7atjvf4">
            Prezzo di Listino: <span className="line-through" data-id="element-64" data-mp="d29cjolc3czo">97€</span>
          </p>
          <p className="font-display text-4xl font-extrabold leading-none text-brand-green sm:text-5xl" data-id="element-65" data-mp="2whsiuahym48">
            OGGI SOLO: 27€
          </p>

          <div className="mt-3" data-id="element-66" data-mp="3pbsrl6rj6em7">
            <CTAButton href={CHECKOUT_URL} data-id="element-67" data-mp="3pahrpi17hr0d">{CTA_LABEL}</CTAButton>
          </div>

          <p className="mt-2 text-[12px] font-bold text-white/80" data-id="element-68" data-mp="3u9uanroyidxo">
            Accesso Immediato • Materiale Didattico in Inglese
          </p>
          <p className="text-[12px] font-bold text-white/80" data-id="element-69" data-mp="3fc1xv7aso3n6">
            🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
          </p>
        </div>
      </div>
    </section>;
}